import { render, staticRenderFns } from "./comp_Breadcrumbs.vue?vue&type=template&id=4e536a8d&scoped=true"
import script from "./comp_Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./comp_Breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./comp_Breadcrumbs.vue?vue&type=style&index=0&id=4e536a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e536a8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VIcon})
